/**
 * <s-menu-dropdown> wraps a native <details> menu and closes it when the
 * visitor clicks outside, presses Escape, or follows a link inside it
 * (needed for same-page anchor links like /#smaken).
 */
class SMenuDropdown extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    if (!this.details) return;

    this.onDocumentClick = (event) => {
      if (this.details.open && !this.contains(event.target)) this.close();
    };
    this.onKeydown = (event) => {
      if (event.key === 'Escape' && this.details.open) {
        this.close();
        this.details.querySelector('summary')?.focus();
      }
    };
    this.onLinkClick = (event) => {
      if (event.target.closest('a')) this.close();
    };

    document.addEventListener('click', this.onDocumentClick);
    this.addEventListener('keydown', this.onKeydown);
    this.addEventListener('click', this.onLinkClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
    this.removeEventListener('keydown', this.onKeydown);
    this.removeEventListener('click', this.onLinkClick);
  }

  close() {
    this.details.open = false;
  }
}

customElements.define('s-menu-dropdown', SMenuDropdown);
